import React from "react";
import { ZoomClient } from "../../../../../../types";
export default React.createContext<ZoomClient>(null as any);
